// Application Constants

export const ROUTES = {
  DASHBOARD: '/',
  COLLECTIONS: '/collections',
  PRODUCTS: '/products',
  CREATE_COLLECTION: '/create-collection',
  ANALYTICS: '/analytics',
  SETTINGS: '/settings'
};

export const COLLECTION_CATEGORIES = [
  'Summer',
  'Winter', 
  'Spring',
  'Fall',
  'Formal',
  'Casual',
  'Sports',
  'Traditional'
];

export const PRODUCT_SIZES = ['L', 'XL', '2XL', '3XL', '4XL', '5XL', '6XL', '7XL'];

export const sortSizes = (sizes = []) =>
  [...sizes].sort((a, b) => PRODUCT_SIZES.indexOf(a) - PRODUCT_SIZES.indexOf(b));

export const PRODUCT_COLORS = [
  'Black',
  'White', 
  'Red',
  'Blue',
  'Green',
  'Yellow',
  'Pink',
  'Purple',
  'Orange',
  'Gray',
  'Brown',
  'Navy',
  'Maroon',
  'Olive'
];

export const SORT_OPTIONS = {
  NEWEST: 'newest',
  OLDEST: 'oldest',
  NAME_ASC: 'name',
  PRICE_LOW: 'price-low',
  PRICE_HIGH: 'price-high',
  STOCK: 'stock'
};

export const FILTER_OPTIONS = {
  ALL: 'all',
  LOW_STOCK: 'low-stock',
  HIGH_PRICE: 'high-price',
  OUT_OF_STOCK: 'out-of-stock'
};

export const STOCK_THRESHOLDS = {
  LOW_STOCK: 10,
  OUT_OF_STOCK: 0,
  HIGH_VALUE: 100
};

export const CURRENCY = '$';

export const DATE_FORMAT = 'MM/DD/YYYY'; 